export default __webpack_public_path__ + "static/finindcase3-1edbd0c7edcead83e88393d94aa7e664.png";